<template>
    <section class="d-flex flex-column align-center justify-end" :class="panelLoading ? 'panel-aniamtion-loader' : 'animation-loader'">
        <div class='sk-circle-bounce'>
            <div :class="panelLoading ? 'sk-panel-child sk-circle-1' : 'sk-child sk-circle-1'" ></div>
            <div :class="panelLoading ? 'sk-panel-child sk-circle-2' : 'sk-child sk-circle-2'" ></div>
            <div :class="panelLoading ? 'sk-panel-child sk-circle-3' : 'sk-child sk-circle-3'" ></div>
            <div :class="panelLoading ? 'sk-panel-child sk-circle-4' : 'sk-child sk-circle-4'" ></div>
            <div :class="panelLoading ? 'sk-panel-child sk-circle-5' : 'sk-child sk-circle-5'" ></div>
            <div :class="panelLoading ? 'sk-panel-child sk-circle-6' : 'sk-child sk-circle-6'" ></div>
            <div :class="panelLoading ? 'sk-panel-child sk-circle-7' : 'sk-child sk-circle-7'" ></div>
            <div :class="panelLoading ? 'sk-panel-child sk-circle-8' : 'sk-child sk-circle-8'" ></div>
            <div :class="panelLoading ? 'sk-panel-child sk-circle-9' : 'sk-child sk-circle-9'" ></div>
            <div :class="panelLoading ? 'sk-panel-child sk-circle-10' : 'sk-child sk-circle-10'" ></div>
            <div :class="panelLoading ? 'sk-panel-child sk-circle-11' : 'sk-child sk-circle-11'" ></div>
            <div :class="panelLoading ? 'sk-panel-child sk-circle-12' : 'sk-child sk-circle-12'"></div>
            <p class="white--text loading-text text-uppercase">Loading</p>
        </div>
    </section>
</template>

<style lang="scss">
$spinkit-size: 6.5em !default;
$spinkit-spinner-color: var(--v-primary-base) !default;
$spinkit-loading-color: #6948C8 !default;
.animation-loader {
    height: 225px;
}
.panel-aniamtion-loader {
    height: 100vh;
    justify-content: center;
    align-items: center;
}
.loading-text {
    margin-top: 15px;
    padding: 27px 27px 27px 22px;
    font-size: 14px;
}
.sk-circle-bounce {
    $circleCount: 12;
    $animationDuration: 1.2s;

    width: $spinkit-size;
    height: $spinkit-size;
    position: relative;
    margin: auto;

    .sk-panel-child, .sk-child {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }

    .sk-panel-child:before {
        content: '';
        display: block;
        margin: 0 auto;
        width: 15%;
        height: 15%;
        background-color: $spinkit-loading-color;
        border-radius: 100%;
        animation: sk-circle-bounce-delay $animationDuration infinite ease-in-out both;
    }

    .sk-child:before {
        content: '';
        display: block;
        margin: 0 auto;
        width: 15%;
        height: 15%;
        background-color: $spinkit-spinner-color;
        border-radius: 100%;
        animation: sk-circle-bounce-delay $animationDuration infinite ease-in-out both;
    }

    @for $i from 2 through $circleCount {
        .sk-circle-#{$i} {
            transform: rotate((360deg / $circleCount * ($i - 1)));
        }
    }

    @for $i from 2 through $circleCount {
        .sk-circle-#{$i}:before {
            animation-delay: (-$animationDuration + $animationDuration / $circleCount * ($i - 1));
        }
    }
}

@keyframes sk-circle-bounce-delay {

    0%,
    80%,
    100% {
        transform: scale(0);
    }

    40% {
        transform: scale(1.0);
    }
}
</style>
<script>
export default {
    name: 'SpinLoader',
    props: {
        panelLoading: {
            type: Boolean,
            default: false
        }
    }
}
</script>